// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row-info[data-v-bac69984]{margin:10px 0;font-weight:700;font-size:1.2rem}", ""]);
// Exports
module.exports = exports;
